import { tw } from "@careinfo/tailwind";
import React from "react";
import loadable from "@loadable/component";
import { useDownload } from "@careinfo/layout";
import moment from "moment";
import APIS from "../../constant/Endpoint";

import { toHaveFormValues } from "@testing-library/jest-dom/matchers";
import Button from "../../components/Reusable/Button";
 
const BalanceSheetComponent = loadable(
  () => import("../../components/BalanceSheet")
);
 

const BalanceSheet = () => {
  const handleDownloadExcel = async () => {
     const { download } = useDownload();
    try {
      const cleanedParams = Object.fromEntries(
        Object.entries(toHaveFormValues)
          .filter(
            ([, value]) => value !== null && value !== undefined && value !== ""
          )
          .map(([key, value]) => [key, String(value)])
      );

      const queryString = new URLSearchParams(cleanedParams).toString();

      await download(
        `${APIS.PRODUCT}valuation-excel-download/?${queryString}`,
        `stock-valuation-${moment().format("MMMM-Do-YYYY-h-mm-ss")}.xlsx`
      );
    } catch (e) {
      console.error(e);
    }
  };
  return (
    <div className={tw`space-y-4`}>
       
      <div className={tw`grid grid-cols-2 pt-2`}>
        
        <h1 className={tw`font-semibold text-2xl leading-10`}>Balance Sheet</h1>
      </div>
       <div className={tw`flex justify-end mb-2`}>
        <div className={tw`w-24`}>
          <Button label="Download" onClick={() => handleDownloadExcel()} />
        </div>
      </div>
      <BalanceSheetComponent />
    </div>
  );
};

export default BalanceSheet;
